import React from 'react';
import { DragSource, DropTarget } from 'react-dnd';
import { Row, Col, Button } from 'react-bootstrap';

import SimplePrompt from 'components/layout/SimplePrompt';

import FormInput from 'components/forms/FormInput';

const source = {
  beginDrag(props) {
    return {
      id: props.id,
      index: props.index,
    };
  },
};

const target = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Time to actually perform the action
    props.moveOption(dragIndex, hoverIndex);

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex;
  },
};

@DropTarget('questionnaireQuestionOption', target, connect => ({
  connectDropTarget: connect.dropTarget(),
}))
@DragSource('questionnaireQuestionOption', source, (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  connectDragPreview: connect.dragPreview(),
  isDragging: monitor.isDragging(),
}))
export default class QuestionnaireQuestionOptionDraggable extends React.Component {
  startEditingOption = () => {
    const { index, startEditingOption } = this.props;
    startEditingOption(index);
  };

  render() {
    const {
      intl: { messages },
      index,
      label,
      connectDragSource,
      connectDropTarget,
      connectDragPreview,
      editLabel,
      editingOption,
      editedOptionIndex,
      updateOption,
      finishEditingOption,
    } = this.props;

    const dragHandle = editingOption ? null : connectDragSource(<i class="fa fa-drag-handle m-r-10" />);

    return connectDragPreview(
      connectDropTarget(
        <div class="m-b-15 bg-master-light padding-10 b-rad-sm">
          <Row>
            <Col xs={8}>
              <div style={{ padding: '6px 0' }}>
                {dragHandle}

                {editingOption && editedOptionIndex === index ? (
                  <FormInput name="label" value={label} onChange={updateOption} />
                ) : (
                  label
                )}
              </div>
            </Col>
            <Col xs={4}>
              <div class="text-right">
                {editingOption && editedOptionIndex === index ? (
                  <Button bsSize="sm" class="btn-rounded m-r-10" onClick={finishEditingOption}>
                    <i className="fal fa-check" />
                  </Button>
                ) : (
                  <React.Fragment>
                    <Button
                      bsSize="sm"
                      class="btn-rounded m-r-10"
                      onClick={this.startEditingOption}
                      disabled={editingOption}
                    >
                      <i class="fa fa-pencil-alt" /> {editLabel}
                    </Button>
                    <SimplePrompt
                      onSuccess={e => {
                        this.props.removeOption(index);
                      }}
                      disabled={editingOption}
                    />
                  </React.Fragment>
                )}
              </div>
            </Col>
          </Row>
        </div>
      )
    );
  }
}
